import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../contexts/LanguageContext";

/**
 * Small "· Privacy · Terms" line reused wherever we need a discreet legal
 * footer (auth shell, cookie banner, etc.). Renders inline as label-eyebrow
 * so it blends with the existing footnotes.
 */
export default function LegalLinks() {
  const { t } = useLang();
  return (
    <div className="label-eyebrow opacity-60 flex items-center justify-center gap-3" data-testid="legal-links">
      <Link
        to="/privacy"
        className="hover:text-white/85 underline decoration-white/20 hover:decoration-white transition-colors"
        data-testid="legal-privacy"
      >
        {t("cookie.privacyLink")}
      </Link>
      <span className="text-white/25">·</span>
      <Link
        to="/terms"
        className="hover:text-white/85 underline decoration-white/20 hover:decoration-white transition-colors"
        data-testid="legal-terms"
      >
        {t("terms.link")}
      </Link>
    </div>
  );
}
